import {
    createContext,
    Dispatch,
    RefObject,
    SetStateAction,
    useContext,
    useRef,
    useState,
} from "react";
import { ClienteEmLoteInterface } from "../../../../../Interfaces/Geral/GestaoClientes/GestaoClientesInterfaces";

interface IComunicadoClienteContext {
    file: File | undefined;
    setFile: Dispatch<SetStateAction<File | undefined>>;
    lstClientesPlanilha: ClienteEmLoteInterface[];
    setLstClientesPlanilha: Dispatch<SetStateAction<ClienteEmLoteInterface[]>>;
    fileInputRef: RefObject<HTMLInputElement>;
}

interface IComunicadoClienteImportarPlanilha {
    children: JSX.Element | JSX.Element[];
}

const ComunicadoClienteContext = createContext<IComunicadoClienteContext>(
    {} as IComunicadoClienteContext
);

export default function ComunicadoClienteImportarPlanilha(
    props: IComunicadoClienteImportarPlanilha
) {
    const [file, setFile] = useState<File>();
    const [lstClientesPlanilha, setLstClientesPlanilha] = useState<
        ClienteEmLoteInterface[]
    >([]);
    const fileInputRef = useRef<HTMLInputElement>(null);

    return (
        <ComunicadoClienteContext.Provider
            value={{
                file,
                setFile,
                lstClientesPlanilha,
                setLstClientesPlanilha,
                fileInputRef,
            }}
        >
            {props.children}
        </ComunicadoClienteContext.Provider>
    );
}

export function useComunicadoClienteImportarPlanilhaContext() {
    const context = useContext(ComunicadoClienteContext);
    if (!context)
        throw new Error(
            "useComunicadoClienteImportarPlanilhaContext necessita de um RegistrarAcordoProvider em volta do que sera utilizado"
        );

    return context;
}
